import {
  getValidCountryCodes,
  countryCodeFound,
  getCountryObjectByCode,
  appendMapTooltip,
  modMap,
  modMapColorBorder,
  darkenColor,
  markerStyle,
  regionStyle,
  flagCdn,
  getSpanishCountryName,
} from "./helper";

jQuery(function ($) {
  if ($("#governance-worldmap").length > 0) {
    // const baseUrl = $('#base-url').data('base-url');

    console.log("governance-worldmap Ready");

    var theMap = $("#governance-worldmap");
    const tip = $(".map-tooltip");
    tip.find('.map-tooltip-close').remove();

    const pageLang = theMap.data("pagelang");

    // Member State
    const msCountriesData = theMap.data("ms-countries");
    const msMarkerCountryCodes = {
      // Barbados
      BB: {
        latLng: [13, -59],
      },
      // Mauritius
      MU: {
        latLng: [-20.2, 57.5],
      },
      // Cape Verde
      CV: {
        latLng: [14.8, -22],
      },
    };
    const msMarkers = msCountriesData.filter((countryData) =>
      msMarkerCountryCodes.hasOwnProperty(countryData.country_code)
    );
    const memberStatesData = msMarkers.map((marker) => {
      const markerData = msMarkerCountryCodes[marker.country_code];
      return {
        ...marker,
        ...markerData,
        style: {
          fill: "#003B7D",
        },
      };
    });

    let mapType = "MS"; // AR = Activity & reach, TH = Themes, MS = Member states
    let activeCountriesData;

    theMap.vectorMap({
      map: "world_mill",
      backgroundColor: "#F9F9FB",
      panOnDrag: true,
      zoomAnimate: true,
      zoomOnScroll: false,
      markerStyle: markerStyle,
      focusOn: {
        x: 0.5,
        y: 0.5,
        scale: 1,
      },
      regionStyle: regionStyle,
      onRegionClick: function (event, code) {
        const countryObj = getCountryObjectByCode(activeCountriesData, code);

        if (countryObj.permalink === undefined) {
          return false;
        }

        window.location = countryObj.permalink;
      },
      onRegionOver: function (e, code) {
        e.preventDefault();
        regionTooltip(e, code);
      },
      onRegionOut: function (e, code) {
        e.preventDefault();
        tip.hide();
        e.target.removeEventListener("mousemove", tooltipMousemove);
      },
      onRegionTipShow: function (e) {
        e.preventDefault();
        return false;
      },
      onViewportChange: function (e, scale) {
        e.preventDefault();
      },
      onMarkerTipShow: function (e, o, s) {
        e.preventDefault();
      },
      onMarkerClick: function (e, index) {
        e.preventDefault();
        const countryObj = memberStatesData[index];
        window.location = countryObj.permalink;
      },
      onMarkerOver: function (e, index) {
        e.preventDefault();
        const code = memberStatesData[index].country_code;
        regionTooltip(e, code);
      },
      onMarkerOut: function (e, index) {
        e.preventDefault();
        tip.hide();
        e.target.removeEventListener("mousemove", tooltipMousemove);
      },
    });
    // theMap.vectormap END ////////////////////////////////////////////////////

    modMap(theMap);
    modMapColorBorder(theMap);

    var myMap = theMap.vectorMap("get", "mapObject");

    // Select/highlight all countries in current map type
    function selectAllCountries(color = "#004587", observerColor = "#36A0E7") {
      const validCountryCodes = getValidCountryCodes(
        myMap,
        activeCountriesData
      );

      validCountryCodes.map((country, index) => {
        const fillColor =
          country.field_member_state === "Observer" ? observerColor : color;
        myMap.regions[country.country_code].element.setStyle("fill", fillColor);
        myMap.regions[country.country_code].element.config.style.selected.fill =
          darkenColor(fillColor, 30);

        theMap
          .find('path[data-code="' + country.country_code + '"]')
          .addClass("selected");
        // myMap.setSelectedRegions(country.country_code);
      });
    }

    function regionTooltip(e, code) {
      if (countryCodeFound(activeCountriesData, code)) {
        const countryObj = getCountryObjectByCode(activeCountriesData, code);

        let content = {};

        content.body = [];

        let yearJoined = "";

        if (
          countryObj.field_year_joined !== null &&
          countryObj.field_year_joined !== ""
        ) {
          yearJoined = " - Joined " + countryObj.field_year_joined;
        }

        let countryName = countryObj.name;

        if (pageLang === "es") {
          countryName = getSpanishCountryName(code);
        }

        let body =
          '<div class="flex items-center justify-center space-x-2 mb-3"><img src="' +
          flagCdn(countryObj.country_code) + '" ' +
          // 'https://flagcdn.com/w160/' +
          // countryObj.country_code.toLowerCase() +
          // '.png" ' + 
          'class="map-tooltip-flag border border-solid border-gray-200" /><span>' +
          countryName +
          yearJoined +
          "</span></div>";

        content.body.push({ text: body });

        appendMapTooltip(tip, content);

        tip.css("position", "fixed");
        tip.show();

        e.target.addEventListener("mousemove", tooltipMousemove);
      }
    }

    // Map init for Member State
    function initMSMap() {
      activeCountriesData = msCountriesData;
      selectAllCountries("#003B7D");
      myMap.addMarkers(memberStatesData);
    }

    // Position map tooltip
    function tooltipMousemove(e) {
      let top = window.pageYOffset || document.documentElement.scrollTop;

      tip.css("top", e.pageY - top + "px");
      tip.css("left", e.pageX + "px");
    }

    // On page load init map type Activity & Reach
    initMSMap();
  } // if END
});
